import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

interface LanguageSwitcherProps {
  color?: string;
}

export default function LanguageSwitcher({ color }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language.startsWith('fr') ? 'fr' : 'en';
  return (
    <Button
      size="small"
      onClick={() => i18n.changeLanguage(currentLang === 'en' ? 'fr' : 'en')}
      sx={{ color: color ?? 'inherit' }}
    >
      {currentLang === 'en' ? 'Français' : 'English'}
    </Button>
  );
}
